import { render, staticRenderFns } from "./LegalPages.vue?vue&type=template&id=4f5a1707&"
import script from "./LegalPages.vue?vue&type=script&lang=js&"
export * from "./LegalPages.vue?vue&type=script&lang=js&"
import style0 from "./LegalPages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QField,QItem,QItemSection,QCheckbox,QItemLabel,QBtn} from 'quasar'
component.options.components = Object.assign({QForm,QField,QItem,QItemSection,QCheckbox,QItemLabel,QBtn}, component.options.components || {})
